
import Vue from 'vue'

import '@/styles/app.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'animate.css/animate.compat.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import AMap from 'vue-amap';
import i18n from './lang'
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
// import animated from 'animate.css'
Vue.use(VideoPlayer)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// Vue.use(ElementUI, { locale })npm run dev
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(AMap)
Vue.config.productionTip = false

AMap.initAMapApiLoader({
  key: '350b9c254c2655f895a4cdfaee3aa0f3',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})

router.beforeEach((to, from, next) => {
  if (to.path) {
    window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  i18n,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js